import React from 'react'

export default function Form() {
  return (
    <>
    <h1>Form</h1>
    <p><code>Form, Input, Select, Textarea</code> elements have a default styling set for them </p>

    <h2>Code:</h2>
    <div className='border-grey pl-1 border-curve bc-grey'>
        <p className='medium'>
          &lt;form&gt;<br/>
          &lt;input type="text" name="fname" /&gt;<br/>
          &lt;input type="email" name="fname" /&gt;<br/>
          &lt;input type="password" name="fname" /&gt;<br/>
          &lt;textarea name="message" rows="10" cols="30"&gt;<br/>
              The cat was playing in the garden.<br/>
          &lt;/textarea&gt;<br/>
          &lt;button type="button" onclick="alert('Hello World!')"&gt;Click Me!&lt;/button&gt;<br/>
          &lt;div&gt;<br/>
              &lt;input type="radio" id="css" name="fav_language" value="CSS"/&gt;<br/>
              &lt;label for="css"&gt;CSS&lt;/label&gt;&lt;br /&gt;<br/>
              &lt;input type="radio" id="css" name="fav_language" value="CSS"/&gt;<br/>
              &lt;label for="css"&gt;CSS&lt;/label&gt;&lt;br /&gt;<br/>
          &lt;/div&gt;<br/>
          &lt;input type="datetime-local" id="birthdaytime" name="birthdaytime" /&gt;<br/>
          &lt;div&gt;<br/>
              &lt;input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" /&gt;<br/>
              &lt;label for="vehicle1"&gt; I have a bike&lt;/label&gt;&lt;br/&gt;<br/>
              &lt;input type="checkbox" id="vehicle2" name="vehicle2" value="Car" /&gt;<br/>
              &lt;label for="vehicle2"&gt; I have a car&lt;/label&gt;&lt;br/&gt;<br/>
              &lt;input type="checkbox" id="vehicle3" name="vehicle3" value="Boat" /&gt;<br/>
              &lt;label for="vehicle3"&gt; I have a boat&lt;/label&gt;<br/>
          &lt;/div&gt;<br/>
            &lt;label for="cars"&gt;Choose a car:&lt;/label&gt;<br/>
              &lt;select id="cars" name="cars"&gt;<br/>
              &lt;option value="volvo"&gt;Volvo&lt;/option&gt;<br/>
              &lt;option value="saab"&gt;Saab&lt;/option&gt;<br/>
              &lt;option value="fiat"&gt;Fiat&lt;/option&gt;<br/>
              &lt;option value="audi"&gt;Audi&lt;/option&gt;<br/>
              &lt;/select&gt;<br/>
        &lt;/form&gt;

      </p>
    </div>

    <h2>Result:</h2>
    <div className='border-grey p-1 border-curve flex-align-xy'>
    <form>
        <input type="text" name="fname" />
        <input type="email" name="fname" />
        <input type="password" name="fname" />
        <textarea name="message" rows="10" cols="30">
            The cat was playing in the garden.
        </textarea>
        <button type="button" onclick="alert('Hello World!')">Click Me!</button>
        <div>
            <input type="radio" id="css" name="fav_language" value="CSS"/>
            <label for="css">CSS</label><br />
            <input type="radio" id="css" name="fav_language" value="CSS"/>
            <label for="css">CSS</label><br />
        </div>
        <input type="datetime-local" id="birthdaytime" name="birthdaytime" />
        <div>
            <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" />
            <label for="vehicle1"> I have a bike</label><br/>
            <input type="checkbox" id="vehicle2" name="vehicle2" value="Car" />
            <label for="vehicle2"> I have a car</label><br/>
            <input type="checkbox" id="vehicle3" name="vehicle3" value="Boat" />
            <label for="vehicle3"> I have a boat</label>
        </div>
          <label for="cars">Choose a car:</label>
            <select id="cars" name="cars">
            <option value="volvo">Volvo</option>
            <option value="saab">Saab</option>
            <option value="fiat">Fiat</option>
            <option value="audi">Audi</option>
            </select>
    </form>
    </div>
  </>
  )
}
